import { InputBoX } from "../../../../common/dataClass/Default"

/**财务国家对应缩写 */
let financialCountryFatherKey = {
  American: 'NorthAmerica', Canada: 'NorthAmerica', Mexico: 'NorthAmerica', Brazil: 'NorthAmerica',
  Britain: 'Europe', France: 'Europe', Italy: 'Europe', Germany: 'Europe', Spain: 'Europe', Netherlands: 'Europe', Athens: 'Europe', Poland: 'Europe', Turkey: 'Europe',
  Japan: 'AsiaPacific', Australia: 'AsiaPacific', Singapore: 'AsiaPacific', India: 'AsiaPacific',
  Emirates: 'NorthAfrica', Arab: 'NorthAfrica', Egypt: 'NorthAfrica'
}

let financialCountryKey = {
  American: 'USA', Canada: 'CAN', Mexico: 'MEX', Brazil: 'BR',
  Britain: 'UK', France: 'FRA', Italy: 'ITA', Germany: 'GER', Spain: 'ESP', Netherlands: 'NLD', Athens: 'SWE', Poland: 'POL', Turkey: 'TUR',
  Japan: 'JPN', Australia: 'AUS', Singapore: 'SGP', India: 'IND',
  Emirates: 'ARE', Arab: 'SAU', Egypt: 'EGY'
}

let shopSettingKey = {
  storeName: 'name',
  amazonTransferDate: 'paymentDate',
  id: 'id'
}

let shopSettingConfigMapKey = {
  mergeConfiguration: 'warehouseConfiguration',
  sellerType: 'sellerType',
  operationFee: 'networkFee',
  softwareFee: 'softwareCost',
  otherFee: 'otherFee',
  returnLossRate: 'serviceRate',
  operationInterestRateYearly: 'operatingAnnualInterestRate',
  foreignExchangeCollectionAgency: 'collectionAgency',
  clerkName: 'storeAdministratorName',
  clerkBankName: 'bankName',
  clerkBankAccount: 'bankCard',
}

let commissionConfigKey = {
  multiStore: 'commissionForStoreManagement',
  borrowStore: 'accountCommission',
}

let storeManagementKey = {
  staffName: 'name',
  bankName: 'bankName',
  bankAccount: 'bankCard',
  phone: 'phone',
  commissionRate: 'rate',
}

/**提成管理 */
class StoreManagement{
  constructor() {
    /**姓名 */
    this.name = ''
    /**银行名称 */
    this.bankName = ''
    /**银行卡号 */
    this.bankCard = ''
    /**手机号 */
    this.phone = ''
    /**提成率 */
    this.rate =  ''
  }
  get getAxiosBody(){
    let obj = {
      staffName: this.name,
      bankName: this.bankName,
      bankAccount: this.bankCard,
      phone: this.phone,
      commissionRate: this.rate,
    }
    return obj
  }
  /**后端返回的详情数据 */
  backendDetailDataParsing(obj){
    if(obj == null) return;
    let sMKey = Object.keys(storeManagementKey)
    sMKey.map(key => {
      this[storeManagementKey[key]] = obj[key]
    })
  }
  /**是否为空数据 */
  judgeEmpty(){
    let keys = Object.keys(this)
    return keys.some(key => !this[key])
  }
  /**清空数据 */
  clearData(){
    let keys = Object.keys(this)
    keys.map(key => this[key] = '')
  }
}

class ShopSetting{
  constructor(isDisable = true, type = 'old') {
    /**是否可修改 */
    this.isDisable = isDisable
    /**是否提示未输入数据 */
    this.isPrompt = false
    /**类型 */
    this.type = type
    /**店铺索引 */
    this.id = ''
    /**店铺名称 */
    this.name = ''
    /**合仓设置 */
    this.warehouseConfiguration = ''
    /**卖家账户类型 */
    this._sellerType = ''
    /**卖家账户月费 */
    this.sellerPrice = ''
    /**独立网络费用 */
    this.networkFee = ''
    /**运营辅助软件月费 */
    this.softwareCost = ''
    /**其他运营费用 */
    this.otherFee = ''
    /**店铺月均财务费 */
    this.financialFee = {
      American: '', Canada: '', Mexico: '', Brazil: '',
      Britain: '', France: '', Italy: '', Germany: '', Spain: '', Netherlands: '', Athens: '', Poland: '', Turkey: '',
      Japan: '', Australia: '', Singapore: '', India: '',
      Emirates: '', Arab: '', Egypt: ''
    }
    /**资金运营年息率 */
    this.operatingAnnualInterestRate = ''
    /**收汇代理公司 */
    this.collectionAgency = ''
    /**收汇服务费率 */
    this.serviceRate = ''
    /**亚马逊划款日期 */
    this.paymentDate = ''
    /**店铺管理员姓名 */
    this.storeAdministratorName = ''
    /**银行名称 */
    this.bankName = ''
    /**银行卡 */
    this.bankCard = ''
    /**店铺运营管理提成 */
    this.operationsManagement = false
    /**多店铺运营管理提成 */
    this.commissionForStoreManagement = new StoreManagement()
    /**店铺账户借用提成 */
    this.accountCommission = new StoreManagement()
  }
  get sellerType(){ return this._sellerType }
  set sellerType(newVal){
    this._sellerType = newVal
    if(newVal){
      this.sellerPrice = 0
    }else{
      this.sellerPrice = 39.99
    }
  }
  /**新建店铺请求体 */
  get getAddStoreAxiosBody(){
    let financialKeys = Object.keys(this.financialFee)
    let financialArr = []
    financialKeys.map(key => {
      if(this.financialFee[key] !== ''){
        financialArr.push({
          countrySite: financialCountryKey[key],
          fee: this.financialFee[key]
        })
      }
    })
    let obj = {
      storeName: this.name,
      area: [0],
      amazonTransferDate: new Date(this.paymentDate).Format('yyyy-MM-dd'),
      configMap:{
        mergeConfiguration: this.warehouseConfiguration,
        sellerType: this.sellerType,
        operationFee: this.networkFee,
        softwareFee: this.softwareCost,
        otherFee: this.otherFee,
        financeFees: financialArr,
        returnLossRate: this.serviceRate,
        operationInterestRateYearly: this.operatingAnnualInterestRate,
        foreignExchangeCollectionAgency: this.collectionAgency,
        clerkName: this.storeAdministratorName,
        clerkBankName: this.bankName,
        clerkBankAccount: this.bankCard,
        commissionConfig: {
          multiStore: this.commissionForStoreManagement.getAxiosBody,
          borrowStore: this.accountCommission.getAxiosBody
        }
      }
    }
    return obj
  }
  /**修改店铺请求体 */
  get getUpdataStoreAxiosBody(){
    let obj = this.getAddStoreAxiosBody
    obj.id = this.id
    return obj
  }
  /**后端返回的详情数据 */
  backendDetailDataParsing(obj){
    let sSKeys = Object.keys(shopSettingKey)
    let sSCKeys = Object.keys(shopSettingConfigMapKey)
    let fCKeys = Object.keys(financialCountryKey)
    let cCKeys = Object.keys(commissionConfigKey)
    sSKeys.map(key => {
      this[shopSettingKey[key]] = obj[key]
    })
    sSCKeys.map(key => {
      this[shopSettingConfigMapKey[key]] = obj.configMap[key]
    })
    obj.configMap.financeFees.map(obj => {
      let key = fCKeys.find(key => obj.countrySite === financialCountryKey[key])
      this.financialFee[key] = obj.fee
    })
    cCKeys.map(key => {
      this[commissionConfigKey[key]].backendDetailDataParsing(obj.configMap.commissionConfig[key])
    })
  }
}

/**店铺设置搜索输入框类 */
class ShopSettingInputBox extends InputBoX{
  constructor(type, name, data, list, obj = {pla: '', isRequired: true, preUnit: '', postUnit: ''}){
    super(type, name, data, obj)
    /**是否必填 */
    this.isRequired = obj.isRequired == undefined ? true : obj.isRequired
    /**对应子项 */
    this.list = list
    /**前面符号 */
    this.preUnit = obj.preUnit? obj.preUnit: ''
    /**后面符号 */
    this.postUnit = obj.postUnit? obj.postUnit: ''
  }
}

/**多店铺运营管理提成 */
let commissionForStoreManagementObj = {
  name: new ShopSettingInputBox('text', '姓名', 'name', {}, {}),
  bankName: new ShopSettingInputBox('text', '银行名称', 'bankName', {}, {}),
  bankCard: new ShopSettingInputBox('text', '银行卡号', 'bankCard', {}, {}),
  phone: new ShopSettingInputBox('text', '手机号', 'phone', {}, {}),
  rate: new ShopSettingInputBox('text', '运营管理提成率', 'rate', {}, { postUnit: 'icon-baifenbi' }),
}
/**店铺帐户借用提成 */
let accountCommissionObj = {
  name: new ShopSettingInputBox('text', '姓名', 'name', {}, {}),
  bankName: new ShopSettingInputBox('text', '银行名称', 'bankName', {}, {}),
  bankCard: new ShopSettingInputBox('text', '银行卡号', 'bankCard', {}, {}),
  phone: new ShopSettingInputBox('text', '手机号', 'phone', {}, {}),
  rate: new ShopSettingInputBox('text', '销售回款管理提成率', 'rate', {}, { postUnit: 'icon-baifenbi' }),
}
/**北美区 */
let NorthAmericaObj = {
  American: new ShopSettingInputBox('number', '美国', 'American', {}, { show: false }),
  Canada: new ShopSettingInputBox('number', '加拿大', 'Canada', {}, { show: false }),
  Mexico: new ShopSettingInputBox('number', '墨西哥', 'Mexico', {}, { show: false }),
  Brazil: new ShopSettingInputBox('number', '巴西', 'Brazil', {}, { show: false }),
}
/**欧洲区 */
let EuropeObj = {
  Britain: new ShopSettingInputBox('number', '英国', 'Britain', {}, { show: false }),
  France: new ShopSettingInputBox('number', '法国', 'France', {}, { show: false }),
  Italy: new ShopSettingInputBox('number', '意大利', 'Italy', {}, { show: false }),
  Germany: new ShopSettingInputBox('number', '德国', 'Germany', {}, { show: false }),
  Spain: new ShopSettingInputBox('number', '西班牙', 'Spain', {}, { show: false }),
  Netherlands: new ShopSettingInputBox('number', '荷兰', 'Netherlands', {}, { show: false }),
  Athens: new ShopSettingInputBox('number', '雅典', 'Athens', {}, { show: false }),
  Poland: new ShopSettingInputBox('number', '波兰', 'Poland', {}, { show: false }),
  Turkey: new ShopSettingInputBox('number', '土耳其', 'Turkey', {}, { show: false }),
}
/**亚太区 */
let AsiaPacificObj = {
  Japan: new ShopSettingInputBox('number', '日本', 'Japan', {}, { show: false }),
  Australia: new ShopSettingInputBox('number', '澳洲', 'Australia', {}, { show: false }),
  Singapore: new ShopSettingInputBox('number', '新加坡', 'Singapore', {}, { show: false }),
  India: new ShopSettingInputBox('number', '印度', 'India', {}, { show: false }),
}
/**中东及北非区 */
let NorthAfricaObj = {
  Emirates: new ShopSettingInputBox('number', '阿联酋', 'Emirates', {}, { show: false }),
  Arab: new ShopSettingInputBox('number', '沙特阿拉伯', 'Arab', {}, { show: false }),
  Egypt: new ShopSettingInputBox('number', '埃及', 'Egypt', {}, { show: false }),
}
/**合仓设置 */
let warehouseObj = {
  warehouseConfiguration: new ShopSettingInputBox('select', '', 'warehouseConfiguration', {})
}
/**卖家帐户月费 */
let sellerPriceObj = {
  sellerType: new ShopSettingInputBox('select', '卖家账户类型', 'sellerType', {}, ),
  sellerPrice: new ShopSettingInputBox('number', '账户月费', 'sellerPrice', {}, { isDisable: true, preUnit: 'icon-meiyuan_o' }),
}
/**店铺独立网络等运营月费 */
let otherFeeObj = {
  networkFee: new ShopSettingInputBox('number', '独立网络费用', 'networkFee', {}, { preUnit: 'icon-el-inco-cmoney' }),
  softwareCost: new ShopSettingInputBox('number', '运营辅助软件月费', 'softwareCost', {}, { preUnit: 'icon-el-inco-cmoney' }),
  otherFee: new ShopSettingInputBox('number', '其他运营费用', 'otherFee', {}, { preUnit: 'icon-el-inco-cmoney' }),
}
/**店铺月均财务费 */
let financialFeeObj = {
  NorthAmerica: new ShopSettingInputBox('input', '北美区', 'NorthAmerica', NorthAmericaObj, { show: false }),
  Europe: new ShopSettingInputBox('input', '欧洲区', 'Europe', EuropeObj, { show: false }),
  AsiaPacific: new ShopSettingInputBox('input', '亚太区', 'AsiaPacific', AsiaPacificObj, { show: false }),
  NorthAfrica: new ShopSettingInputBox('input', '中东及北非区', 'NorthAfrica', NorthAfricaObj, { show: false }),
}
/**资金运营成本 */
let operatingCostObj = {
  operatingAnnualInterestRate: new ShopSettingInputBox('number', '资金运营年息率', 'operatingAnnualInterestRate', {}, { postUnit: 'icon-baifenbi' }),
}
/**收汇详情 */
let collectionDetailsObj = {
  collectionAgency: new ShopSettingInputBox('select', '收汇代理公司', 'collectionAgency', {}),
  serviceRate: new ShopSettingInputBox('number', '收汇服务费率', 'serviceRate', {}, { postUnit: 'icon-baifenbi' }),
  paymentDate: new ShopSettingInputBox('datePicker', '亚马逊划款日期', 'paymentDate', {}),
}
/**店铺管理员 */
let administratorObj = {
  storeAdministratorName: new ShopSettingInputBox('number', '姓名', 'storeAdministratorName', {}),
  bankName: new ShopSettingInputBox('number', '银行名称', 'bankName', {}),
  bankCard: new ShopSettingInputBox('number', '银行卡号', 'bankCard', {}),
}
/**店铺运营管理提成 */
let managementCommissionObj = {
  commissionForStoreManagement: new ShopSettingInputBox('text', '多店铺运营管理提成', 'commissionForStoreManagement', commissionForStoreManagementObj, { show: false }),
  accountCommission: new ShopSettingInputBox('text', '店铺帐户借用提成', 'accountCommission', accountCommissionObj, { show: false }),
}

class ShopSettingNewModule{
  static NEWINPUTMODULE(){
    let obj = {
      warehouse: new ShopSettingInputBox('input', '合仓设置', 'warehouse', warehouseObj),
      sellerPrice: new ShopSettingInputBox('input', '卖家帐户月费', 'sellerPrice', sellerPriceObj),
      otherFee: new ShopSettingInputBox('input', '店铺独立网络等运营月费', 'otherFee', otherFeeObj),
      financialFee: new ShopSettingInputBox('financial', '店铺月均财务费', 'financialFee', financialFeeObj),
      operatingCost: new ShopSettingInputBox('input', '资金运营成本', 'operatingCost', operatingCostObj),
      collectionDetails: new ShopSettingInputBox('input', '收汇详情', 'collectionDetails', collectionDetailsObj),
      administrator: new ShopSettingInputBox('input', '店铺管理员', 'administrator', administratorObj),
      managementCommission: new ShopSettingInputBox('check', '店铺运营管理提成', 'managementCommission', managementCommissionObj),
    }
    return obj
  }
  /**店铺涉及区域和国家 */
  static GETAREAANDCOUNTRY(array){
    class textObj{
      constructor(areaName, countryName) {
        this.areaName = areaName
        this.countryName = countryName
      }
    }
    let fCKeys = Object.keys(financialCountryKey)
    let resultArray = array.map(obj => {
      let key = fCKeys.find(key => obj.countrySite === financialCountryKey[key])
      let area = financialCountryFatherKey[key]
      let countryName = [area + 'Obj'][key].name
      let areaName = financialFeeObj[area].name
      return new textObj(areaName, countryName)
    })
    return resultArray
  }
}

function getAreaAndCountry(array){
  class textObj{
    constructor(areaName, countryName) {
      this.areaName = areaName
      this.country = countryName
    }
  }
  let fCKeys = Object.keys(financialCountryKey)
  let resultArray = array.map(obj => {
    let key = fCKeys.find(key => obj.countrySite === financialCountryKey[key])
    let area = financialCountryFatherKey[key]
    let countryName = { name: eval(area + 'Obj')[key].name, id: obj.countrySite}
    let areaName = financialFeeObj[area].name
    return new textObj(areaName, countryName)
  })
  return resultArray
}

export {
  ShopSetting, ShopSettingNewModule, financialCountryKey,
  financialCountryFatherKey, commissionConfigKey, getAreaAndCountry,
  StoreManagement
}
